export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-ta-IN.62e7fdb6.xlsx";